import type { CmsStoreFieldData } from "@/types/location";

export function formatLocationAddressLine(
  fieldData: CmsStoreFieldData,
): string {
  const street = fieldData.address.trim();
  const city = fieldData.locationCity?.trim() ?? "";
  const state = fieldData.state?.trim() ?? "";
  const zip = fieldData.zipCode?.trim() ?? "";

  if (street && city && state && zip) {
    return `${street}, ${city}, ${state} ${zip}`;
  }

  return street;
}
